import {ROUTER} from 'constants/actions';
import {ActionType} from '@typescript/common/actionTypes';
import {RouterInfoType} from 'reducers/routerInfo/routerInfoType';

/**
 * DEPRECATED NAME
 * SET page info information
 * @param {RouterInfoType} routerInfo - Router information
 * @returns {ActionType<RouterInfoType>} - Action
 */
export function setPageInfo(routerInfo: RouterInfoType): ActionType<RouterInfoType> {
    return {
        type: ROUTER.SET,
        payload: routerInfo,
    };
}

/* The more suitable alias of the setPageInfo action */
export {setPageInfo as setRouterInfo};
